import { render } from "./pageHeading.vue?vue&type=template&id=ae9596ea&scoped=true"
import script from "./pageHeading.vue?vue&type=script&lang=js"
export * from "./pageHeading.vue?vue&type=script&lang=js"

import "./pageHeading.vue?vue&type=style&index=0&id=ae9596ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae9596ea"]])

export default __exports__